import React from "react";
import { Field } from 'redux-form/immutable';
import { SelectField } from 'redux-form-antd';
import {
    required, nullValue0
} from '../../validDesc';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
}

const ClubFridaySelect = props => {
    const club_monday_select = [
        {
            label: '-- 請選擇 --',
            value: '0'
        },
        {
            value: '540',
            label: '4:50自接'
        },
        {
            value: '500',
            label: '安親1-2年級'
        },
        {
            value: '527',
            label: '英文口語訓練1-2年級'
        },
        {
            value: '528',
            label: '跆拳道'
        },
        {
            value: '531',
            label: '日語初階—【50音與基礎會話】'
        },
        {
            value: '532',
            label: '美術初階1-2年級—【我是創意小玩家】'
        },
        {
            value: '534',
            label: '活力啦啦舞1-3年級'
        },
        {
            value: '535',
            label: '直排輪進階1-3年級'
        },
        {
            value: '538',
            label: '鋼琴'
        },
        {
            value: '539',
            label: '小提琴'
        },
    ]
    const club_friday_display_options = club_monday_select.map(item => (
        item.value === '0' ? item : { ...item, label: `[${item.value}]${item.label}` }
    ));
    return (
        <div>
             <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label="星期五"
                options={club_friday_display_options} name="club_friday" type="text"></Field>
        </div>
    )
}

export default ClubFridaySelect



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentClubForm/ClubFridaySelect.jsx